module.exports = __webpack_public_path__ + "static/media/law-beta_version-02_20210507.a454d63a.svg";